import {
  kEnableCustomOrderTags,
  OrderTagList,
} from '@euler/app/flows/order/components/OrderTagList';
import { ErrorText } from '@euler/components/form/Input';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { getValidateErrorMessage } from '@euler/lib/form/controller';
import { parseTagsFromString } from '@euler/utils';
import { usePersistFn } from '@euler/utils/hooks';
import { memo } from 'react';
import { useOrderFlowContext } from '../../../../OrderFlowContext';
import { Cell } from '../components/Cell';
import { IconWrapper } from '../components/IconWrapper';
import { Row } from '../components/Row';

export const OrderTagsRow = memo(
  ({
    required = true,
    ...props
  }: {
    required?: boolean;
    disabled?: boolean;
  }) => {
    const {
      theme,
      formController: { form },
    } = useOrderFlowContext();

    const { rpx } = useResponsiveContext();

    const { iconColor } = theme;

    const onAddOrderTag = usePersistFn((tag: string) => {
      const list = new Set(form.tags.value ?? []);
      const tags = parseTagsFromString(tag);
      tags.forEach(x => list.add(x));
      form.tags.update([...list]);
    });

    const onRemoveOrderTag = usePersistFn((tag: string) => {
      const list = new Set(form.tags.value ?? []);
      list.delete(tag);
      form.tags.update([...list]);
    });

    return (
      <Row
        errorProp="tags"
        icon={
          <IconWrapper>
            <Icon name="hashtag" color={iconColor} size={rpx(20)} />
          </IconWrapper>
        }
        {...props}
      >
        <Cell label="业务类型" required={required}>
          <OrderTagList
            editable={!props.disabled}
            title="选择业务类型"
            description={
              kEnableCustomOrderTags
                ? '或者点击“自定义”输入自定义业务类型'
                : undefined
            }
            placeholder="选择业务类型"
            tags={form.tags.value}
            onAddTag={onAddOrderTag}
            onTagRemoved={onRemoveOrderTag}
          />
          {form.tags.error ? (
            <ErrorText
              errorMsg={getValidateErrorMessage(form.tags.error)}
              css={`
                margin-top: ${rpx(8)}px;
              `}
            />
          ) : null}
        </Cell>
      </Row>
    );
  },
);
